import React from 'react'
import { useOneTrustBundles, usePrivacyOptOutCheck } from '../../../../shared/utils/hooks'
import { sanitizeHTML } from '../../../../shared/utils/common-utils'
const App = () => {
  const showOptOut = usePrivacyOptOutCheck()
  const { oneTrustLabel, oneTrustUrl } = useOneTrustBundles()

  return (
    <>
      {showOptOut && oneTrustLabel && (
        <div className='Disclaimer-text'>
          <a href={sanitizeHTML(oneTrustUrl)} target='_blank' rel='noopener noreferrer'>
            {oneTrustLabel}
          </a>
        </div>
      )}
    </>
  )
}
export default App
